import Vue from 'vue'

// 全局动画样式
import 'animate.css';

// 自定义指令：滚动显示动画
Vue.directive('scroll-animation', {
  inserted: function (el, binding) {
    let f = function () {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('animate__animated', binding.value || 'animate__fadeIn');
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
    f();
  }
});

// 自定义指令：悬停动画
Vue.directive('hover-animation', {
  bind: function (el, binding) {
    el.addEventListener('mouseenter', () => {
      el.classList.add('animate__animated', binding.value || 'animate__pulse');
    });
    el.addEventListener('mouseleave', () => {
      el.classList.remove('animate__animated', binding.value || 'animate__pulse');
    });
  }
});

// 自定义指令：点击波纹效果
Vue.directive('ripple', {
  bind: function (el) {
    el.style.position = 'relative';
    el.style.overflow = 'hidden';
    
    el.addEventListener('click', (e) => {
      const rect = el.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const ripple = document.createElement('span');
      ripple.className = 'ripple-effect';
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      
      el.appendChild(ripple);
      
      setTimeout(() => {
        ripple.remove();
      }, 600);
    });
  }
});

// 全局混入：页面过渡效果
Vue.mixin({
  beforeRouteEnter(to, from, next) {
    next(() => {
      // 页面进入动画
      document.body.classList.add('page-transition');
      setTimeout(() => {
        document.body.classList.remove('page-transition');
      }, 500);
    });
  }
});

// 全局CSS
const style = document.createElement('style');
style.innerHTML = `
  .ripple-effect {
    position: absolute;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
    transform: scale(0);
    animation: ripple 0.6s linear;
    pointer-events: none;
  }
  
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  
  .page-transition {
    animation: pageFadeIn 0.5s ease;
  }
  
  @keyframes pageFadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .hover-scale {
    transition: transform 0.3s ease;
  }
  
  .hover-scale:hover {
    transform: scale(1.05);
  }
  
  .hover-shadow {
    transition: box-shadow 0.3s ease;
  }
  
  .hover-shadow:hover {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  }
  
  .dark-mode .hover-shadow:hover {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  }
`;
document.head.appendChild(style);
